const isExcludedFromCalculatedMargin = (tab) => {
	const flag = tab?.ExcludedFromCalculatedMargin;
	return flag === true || flag === 1 || flag === "1";
};

export const quoteHasExcludedFromCalculatedMarginTab = (quote) => {
	const tabs = quote?.Tabs;
	if (!tabs) {
		return false;
	}
	if (typeof tabs.where === "function") {
		return tabs.where((tab) => isExcludedFromCalculatedMargin(tab)).length > 0;
	}
	if (Array.isArray(tabs)) {
		return tabs.some((tab) => isExcludedFromCalculatedMargin(tab));
	}
	if (typeof tabs.length === "number") {
		for (let i = 0; i < tabs.length; i++) {
			if (isExcludedFromCalculatedMargin(tabs[i])) {
				return true;
			}
		}
	}
	return false;
};

const isDefinedMarginMetric = (value) =>
	value != null && String(value).trim() !== "";

export const metricValuesDiffer = (standardValue, nonExcludedValue) => {
	if (!isDefinedMarginMetric(standardValue) && !isDefinedMarginMetric(nonExcludedValue)) {
		return false;
	}
	if (!isDefinedMarginMetric(standardValue)) {
		return isDefinedMarginMetric(nonExcludedValue);
	}
	if (!isDefinedMarginMetric(nonExcludedValue)) {
		return true;
	}
	const standardNumber = Number(standardValue);
	const nonExcludedNumber = Number(nonExcludedValue);
	if (!Number.isNaN(standardNumber) && !Number.isNaN(nonExcludedNumber)) {
		return standardNumber !== nonExcludedNumber;
	}
	return String(standardValue).trim() !== String(nonExcludedValue).trim();
};

export const shouldShowOneTimeMarginViewMenu = (quote, anyTabExcluded) => {
	return anyTabExcluded;
};

export const shouldShowRecurringMarginViewMenu = (
	quote,
	recurringPrefix,
	anyTabExcluded,
	_metrics
) => {
	return anyTabExcluded;
};
